import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { IFillDataWizardBuy, TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../../..";
import EstimateStep from "../../../../../../../shared/wizard/steps/estimateStep";
import { IDataFormEstimate } from "../../../../../../estimate";

interface IWishSwapStepBuy_1 {
  isNextStepDisabled: boolean;
  onChange: (data: Partial<IFillDataWizardBuy>) => void;
  onChangePrice:(data: number | number[], key: TNumberKeysOfIFillDataWizardBuy) => void,
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
  dataFormEstimate: Partial<IFillDataWizardBuy>;
}

const WishSwapStepBuy_1 = ({
  isNextStepDisabled,
  onChange,
  onChangePrice,
  onReset,
  dataFormEstimate,
}: IWishSwapStepBuy_1) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.step_9);
    onReset(["streetId", "buildingId", "areaInSqM", "apartmentNumber"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.wishesSteps.swap.step_2);
  };

  const dataFormEstimateChecked = Boolean(
    dataFormEstimate.areaInSqM &&
      dataFormEstimate.buildingId &&
      dataFormEstimate.streetId
  );

  const handleEstimatePrice = (value: number) => {
    onChangePrice(value, "estimatedPrice");
  };

  return (
    <div>
      <EstimateStep
        mode="quiz"
        onEstimateForm={onChange}
        onEstimatePrice={handleEstimatePrice}
        onNexStep={handleNexStep}
        onPrevStep={handlePrevStep}
        isNextStepDisabled={isNextStepDisabled}
        dataFormEstimate={
          dataFormEstimateChecked
            ? (dataFormEstimate as IDataFormEstimate)
            : undefined
        }
      />
    </div>
  );
};

export default WishSwapStepBuy_1;
